import React from 'react'

import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import { ButtonNext } from '@/modules/base/components/buttons/index'
import ApproveWrapper from './approve-wrapper'
import { useNavigate } from 'react-router'

const useStyles = makeStyles(theme => ({
  subtitle: {
    textAlign: 'center',
  },
  loginButton: {
    width: '100%',
    marginTop: '15px',
  },
}))

const Success = () => {
  const navigate = useNavigate()
  const classes = useStyles()

  const handleSubmitSucces = () => {
    navigate('/account/login')
  }

  return (
    <ApproveWrapper title={lang.approvedTitle}>
      <p className={classes.subtitle}>{lang.approvedDescription}</p>
      <ButtonNext
        label={lang.approvedButtonLabel}
        customClass={classes.loginButton}
        onClick={handleSubmitSucces} />
    </ApproveWrapper>
  )
}

export default Success
